import React from 'react';

const MarketplaceFooter = ({ onOpenAgentRegister }) => {
  return (
    <footer className="bg-slate-900 text-white mt-12" data-testid="marketplace-footer">
      {/* Feature strip */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-cyan-500/20 text-cyan-500 flex items-center justify-center">
              <i className="fa-solid fa-mobile-screen text-lg" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-white/50">Download SchoolVerse App</p>
              <p className="text-sm font-bold">Get exclusive offers on the app</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-cyan-500/20 text-cyan-500 flex items-center justify-center">
              <i className="fa-solid fa-credit-card text-lg" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-white/50">Payment Methods</p>
              <p className="text-sm font-bold">Pay how you want</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-cyan-500/20 text-cyan-500 flex items-center justify-center">
              <i className="fa-solid fa-headset text-lg" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-white/50">Customer Service</p>
              <p className="text-sm font-bold">We are here to help</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-cyan-500/20 text-cyan-500 flex items-center justify-center">
              <i className="fa-solid fa-share-nodes text-lg" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-white/50">Let&apos;s Stay Connected</p>
              <p className="text-sm font-bold">Follow us on social media</p>
            </div>
          </div>
        </div>
      </div>

      {/* Link columns */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="inline-flex items-center rounded-xl bg-white px-2 py-1 mb-3">
            <img src="/schoolverse-logo.png" alt="SchoolVerse" className="h-10 w-auto max-w-[190px] object-contain" />
          </div>
          <p className="text-xs text-white/60 leading-relaxed mb-3">YOUR CAMPUS. YOUR BUSINESS. YOUR WORLD.</p>
          <p className="text-xs text-white/60 mb-1">
            <i className="fa-solid fa-envelope mr-2 text-cyan-500" /> help@shopimax.com
          </p>
          <p className="text-xs text-white/60">
            <i className="fa-solid fa-phone mr-2 text-cyan-500" /> +234 800 123 4567
          </p>
        </div>

        <div>
          <h4 className="text-sm font-bold mb-3 text-white">Shop</h4>
          <ul className="space-y-2 text-xs text-white/70">
            <li><a href="#/deals" className="hover:text-cyan-500">Deals & Promotions</a></li>
            <li><a href="#" className="hover:text-cyan-500">New Arrivals</a></li>
            <li><a href="#" className="hover:text-cyan-500">Top Selling</a></li>
            <li><a href="#" className="hover:text-cyan-500">Brands</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold mb-3 text-white">Customer Care</h4>
          <ul className="space-y-2 text-xs text-white/70">
            <li><a href="#" className="hover:text-cyan-500">Help Center</a></li>
            <li><a href="#" className="hover:text-cyan-500">Track Order</a></li>
            <li><a href="#" className="hover:text-cyan-500">Returns</a></li>
            <li><a href="#" className="hover:text-cyan-500">Contact Us</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold mb-3 text-white">Make Money</h4>
          <ul className="space-y-2 text-xs text-white/70">
            <li>
              <button onClick={onOpenAgentRegister} className="hover:text-cyan-500">
                Sell on SchoolVerse
              </button>
            </li>
            <li><a href="#" className="hover:text-cyan-500">Become an Agent</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold mb-3 text-white">Follow Us</h4>
          <div className="flex items-center gap-3">
            <a href="#" className="w-8 h-8 rounded-full bg-white/10 hover:bg-cyan-500 flex items-center justify-center transition-colors">
              <i className="fa-brands fa-facebook-f text-sm" />
            </a>
            <a href="#" className="w-8 h-8 rounded-full bg-white/10 hover:bg-cyan-500 flex items-center justify-center transition-colors">
              <i className="fa-brands fa-instagram text-sm" />
            </a>
            <a href="#" className="w-8 h-8 rounded-full bg-white/10 hover:bg-cyan-500 flex items-center justify-center transition-colors">
              <i className="fa-brands fa-x-twitter text-sm" />
            </a>
            <a href="#" className="w-8 h-8 rounded-full bg-white/10 hover:bg-cyan-500 flex items-center justify-center transition-colors">
              <i className="fa-brands fa-tiktok text-sm" />
            </a>
            <a href="#" className="w-8 h-8 rounded-full bg-white/10 hover:bg-cyan-500 flex items-center justify-center transition-colors">
              <i className="fa-brands fa-youtube text-sm" />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <p>© {new Date().getFullYear()} SchoolVerse. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-cyan-500">Privacy Policy</a>
            <a href="#" className="hover:text-cyan-500">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MarketplaceFooter;
